import { Typography, Box, Divider, Link, IconButton } from '@mui/material'
import FacebookIcon from '@mui/icons-material/Facebook'

export default function Footer() {
  const socialLinks = [
    {
      href: 'https://www.facebook.com/p/Hock-Tyre-Singapore-100057589842217/',
      icon: <FacebookIcon fontSize='large' style={{ fill: 'white' }} />,
    },
  ]

  const address = [
    {
      address: '219, Kaki Bukit Ave 1, Shun Li Industrial Park, Singapore 416044',
      tel: '+65 8799 7587',
      email: 'enquiry@hocktyre.com.sg',
    },
  ]

  return (
    <Box
      bgcolor='#222222'
      color='#ffff'
      px={3}
      py={5}
      display='flex'
      justifyContent='space-between'
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems='center'
      textAlign={{ xs: 'center', md: 'left' }}
      mt={10}
    >
      <Box flexGrow={1} maxWidth={900}>
        <Box mb={1}>
          <Typography fontSize='1.25rem' fontFamily={'GothicBold'}>
            Contact
          </Typography>
        </Box>
        <Box mb={1}>
          <Divider style={{ background: 'white' }} />
        </Box>
        <Box mb={1}>
          <Typography fontSize='0.875rem' fontFamily={'GothicBold'}>
            Hock Tyre Pte Ltd
          </Typography>
        </Box>
        {address.map((item, index) => (
          <Box key={index} pt={1} color='#ffff' fontSize='0.875rem'>
            <Typography fontSize='0.875rem'>{item.address}</Typography>
            <Box display='flex' flexDirection={{ xs: 'column', md: 'row' }}>
              <Typography fontSize='0.875rem'>Tel: {item.tel}</Typography>
              <Box marginLeft={{ md: 2 }}>
                <Typography fontSize='0.875rem'>Email: {item.email}</Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
      <Box pt={1} pl={{ xs: 0, md: 5 }} minWidth='100px'>
        {socialLinks.map(({ href, icon }, index) => (
          <Link href={href} target='_blank' key={index}>
            <IconButton>{icon}</IconButton>
          </Link>
        ))}
      </Box>
    </Box>
  )
}
